import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawNumberInput, type RawNumberInputProps } from './RawNumberInput'

export type NumberInputProps = RawNumberInputProps & InputProps

export const NumberInput = ({
  wrapperProps,
  ...fieldProps
}: NumberInputProps) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawNumberInput {...fieldProps} id={id} />
    </InputWrapper>
  )
}
